const AUTH_BASE_URL = process.env.NEXT_PUBLIC_AUTH_URL;
const CLIENT_ID = "momo";

export const getAuthRedirectUrl = ({ redirectUri }: { redirectUri: string }) => {
  return getAuthSigninUrl(redirectUri);
};

export const getAuthTopUrl = (redirect_uri: string) => {
  return (
    `${AUTH_BASE_URL}` +
    "?" +
    new URLSearchParams({
      client_id: CLIENT_ID,
      redirect_uri: redirect_uri,
    }).toString()
  );
};

export const getAuthSigninUrl = (redirect_uri: string) => {
  return (
    `${AUTH_BASE_URL}/signin` +
    "?" +
    new URLSearchParams({
      client_id: CLIENT_ID,
      redirect_uri: redirect_uri,
    }).toString()
  );
};

export const getAuthSignoutUrl = (redirect_uri: string) => {
  return (
    `${AUTH_BASE_URL}/signout` +
    "?" +
    new URLSearchParams({
      client_id: CLIENT_ID,
      redirect_uri: redirect_uri,
    }).toString()
  );
};

export const getAuthSettingsUrl = (redirect_uri: string) => {
  return (
    `${AUTH_BASE_URL}/settings` +
    "?" +
    new URLSearchParams({
      client_id: CLIENT_ID,
      redirect_uri: redirect_uri,
    }).toString()
  );
};

export const getAuthCreditCardRegistrationUrl = () => {
  return (
    `${AUTH_BASE_URL}` +
    "/embed/credit-cards/add?" +
    new URLSearchParams({
      client_id: CLIENT_ID,
    }).toString()
  );
};
